/**
 * searchFilter
 * @param {string} searchText - initial searchText for search, can includes several terms separated by spaces
 * @param {array} propList - properties to filter on, filter on item itself if undefined
 */

function searchFilter(searchText, propList) {
  const searchTerms = searchText.toLowerCase().split(/\s+/);
  const match = (str) => {
    if (!str) {
      return false;
    }
    const lcStr = str.toString().toLowerCase();
    return searchTerms.every((term) => lcStr.includes(term));
  };
  return (list) => {
    if (!searchText) {
      return list;
    }
    if (!propList) {
      return list.filter(match);
    }
    return list.filter((item) => propList.some((prop) => match(item[prop])));
  };
}

export default searchFilter;
